export default __webpack_public_path__ + "images/IN.svg";